<template>
    <div class="favorite">
        <!--{{keyword}}-->
        <!--{{searchList}}-->

        <!--{{userId}}-->
        <!--{{favoriteList}}-->

        <div class="article-list-main">
            <div class="article-list-container">
                <el-card class="article-list-item-container" v-for="(item,index) in favoriteList" :key="index">
                    <div><h3>{{item.title}}</h3></div>
                    <div><h6>{{item.summary}}</h6></div>
                    <router-link :to="'/article/articleDetail/' + item.articleId" target="_blank">
                        <a @click="addViewCount(item.articleId)">查看详情</a>
                    </router-link>

                    <el-button style="float: right" @click="delFavorite(item.id)">取消收藏</el-button>
                </el-card>
            </div>

            <el-pagination
                    class="page"
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    @prev-click="handlePrevClick"
                    @next-click="handleNextClick"
                    :current-page="currentPage"
                    :page-sizes="[10 , 20, 30, 40 ,50 ,60]"
                    :page-size="30"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total=total>
            </el-pagination>

        </div>

    </div>
</template>

<script>
    import {getFavoriteList,delFavoriteById} from "@/api/favorite";
    import {addViewCount} from "@/api/post";

    export default {
        name: "Favorite",
        data(){
            return{
                userId:"",
                favoriteList:[],
                total:0,
                currentPage: 1,
                pageNum:1,
                pageSize:30,

                freshen:0,
            }
        },

        watch: {
            /*监听是否取消收藏了*/
            freshen:{
                handler(){
                    this.getFavoriteList(this.userId,this.pageNum,this.pageSize);
                },
                immediate: true
            },
        },

        created() {
            this.userId = this.$store.state.user.userId;
            this.getFavoriteList(this.userId,this.pageNum,this.pageSize);
        },
        methods: {
            addViewCount(articleId){
                //文章流量数+1
                addViewCount(articleId).then();
            },

            handleSizeChange(val) {
                this.pageSize=val
                this.getFavoriteList(this.userId,this.pageNum,val)
            },
            handleCurrentChange(val) {
                this.pageNum=val
                this.getFavoriteList(this.userId,val,this.pageSize)
            },
            handlePrevClick(val){
                this.getFavoriteList(this.userId,val,this.pageSize)
            },
            handleNextClick(val){
                this.getFavoriteList(this.userId,val,this.pageSize)
            },

            //用户获取收藏列表
            getFavoriteList(userId,pageNum,pageSize){
                getFavoriteList(userId,pageNum,pageSize).then(response => {
                    if (response.code === 200){
                        this.favoriteList = response.rows;
                        this.total = response.total;
                    }else {
                        this.$message({
                            showClose: true,
                            message: response.msg,
                            type: 'error'
                        });
                    }
                });
            },

            delFavorite(id){
                this.$confirm('确定要删除该收藏吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delFavoriteById(id).then(response => {
                        if (response.code===200){
                            this.$message({
                                showClose: true,
                                message: response.msg,
                                type: 'success'
                            });
                            this.freshen = this.freshen+1
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.msg,
                                type: 'error'
                            });
                        }
                    });
                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });
            },
        }
    }
</script>

<style scoped>
    .favorite{
        width: 60%;
        margin: 0 auto;
        padding-bottom: 20px;
    }
    /*.article-list-item-container{*/
        /*padding: 40px;*/
        /*margin: 20px;*/
    /*}*/
    .page{
        float: right;
        margin-right: 30px;
    }

    .article-list-item-container {
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    }

    .article-list-item-container :hover{
        background: #f9f9f9;
    }

    .article-list-item :hover{
        color: #6495ED;
    }

    .article-list-item{
        text-decoration: none;
        color: black;
    }
</style>
